// src/telemetry/constants/actions.ts

export const ACTIONS = {
  // Navigation
  PAGE_VIEW: 'page_view',

  // Authentication
  LOGIN: 'login',
  LOGOUT: 'logout',

  // Profile
  SAVE_PROFILE: 'save_profile',
  EDIT_PROFILE: 'edit_profile',
  VERIFY_EMAIL: 'verify_email',
  VERIFY_PHONE: 'verify_phone',
  CHANGE_PASSWORD: 'change_password',

  // Business Details
  ADD_PRODUCT: 'add_product',
  DELETE_PRODUCT: 'delete_product',
  ADD_SERVICE: 'add_service',
  DELETE_SERVICE: 'delete_service',
  UPLOAD_LOGO: 'upload_logo',
  UPLOAD_ATTACHMENT: 'upload_attachment',

  // Generic CRUD
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',

  // Files
  DOWNLOAD: 'download',
  EXPORT: 'export',

  // Publishing
  PUBLISH: 'publish',

  // Utility Manager
  SELECT_KEYWORD: 'select_keyword',
  DESELECT_KEYWORD: 'deselect_keyword',
  EDIT_KEYWORDS: 'edit_keywords',
  LOCK_KEYWORD_UNIVERSE: 'lock_keyword_universe',

  // SEO Manager
  VIEW_AS_IS_STATE: 'view_as_is_state',
  SET_GOALS: 'set_goals',
  GENERATE_ACTION_PLAN: 'generate_action_plan',
  COMPLETE_TASK: 'complete_task',

  // Content Manager
  GENERATE_CONTENT: 'generate_content',
  EDIT_CONTENT: 'edit_content',
  APPROVE_CONTENT: 'approve_content',
  REJECT_CONTENT: 'reject_content',
  SCHEDULE_POST: 'schedule_post',
  PUBLISH_POST: 'publish_post',
  RETRY_POST: 'retry_post',
  PUBLISH_CONTENT: 'publish_content',

  // Website Builder
  CREATE_PAGE: 'create_page',
  EDIT_PAGE: 'edit_page',
  EDIT_WEBSITE: 'edit_website',
  DELETE_PAGE: 'delete_page',
  REORDER_PAGES: 'reorder_pages',
  PREVIEW_WEBSITE: 'preview_website',
  GENERATE_WEBSITE: 'generate_website',
  PUBLISH_WEBSITE: 'publish_website',

  // Reporting
  VIEW_REPORT: 'view_report',
  GENERATE_REPORT: 'generate_report',
  EXPORT_REPORT: 'export_report',
  CHANGE_DATE_RANGE: 'change_date_range',

  // Support
  CREATE_TICKET: 'create_ticket',
  REPLY_TICKET: 'reply_ticket',
  VIEW_TICKET: 'view_ticket',
  CLOSE_TICKET: 'close_ticket',
  VIEW_FAQ: 'view_faq',
  VIEW_GUIDE: 'view_guide',
  WATCH_TUTORIAL: 'watch_tutorial',

  // Integrations
  CONNECT_INTEGRATION: 'connect_integration',
  DISCONNECT_INTEGRATION: 'disconnect_integration',
  SYNC_DATA: 'sync_data',

  // Billing
  VIEW_SUBSCRIPTION: 'view_subscription',
  APPLY_COUPON: 'apply_coupon',
  REMOVE_COUPON: 'remove_coupon',
  INITIATE_PAYMENT: 'initiate_payment',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_FAILED: 'payment_failed',
  DOWNLOAD_INVOICE: 'download_invoice',

  // AI Assistant (Kiki)
  OPEN_CHATBOT: 'open_chatbot',
  CLOSE_CHATBOT: 'close_chatbot',
  SEND_MESSAGE: 'send_message',
  USE_SUGGESTED_PROMPT: 'use_suggested_prompt',

  // Notifications
  MARK_READ: 'mark_read',
  MARK_ALL_READ: 'mark_all_read',

  // System
  HEARTBEAT: 'heartbeat',
} as const;

export type ActionName =
  typeof ACTIONS[keyof typeof ACTIONS];
